import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-layout-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.admin/view.scss */
/* src/app/layout.admin/view.scss: no such file or directory */`],
})
export class LayoutAdminComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public mobileNavOpen: boolean = false;
    private navSub: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership("admin", "/");
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(async () => {
                this.mobileNavOpen = false;
                await this.service.render();
            });
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    public async toggleMobileNav() {
        this.mobileNavOpen = !this.mobileNavOpen;
        await this.service.render();
    }

    public async closeMobileNav() {
        this.mobileNavOpen = false;
        await this.service.render();
    }
}

export default LayoutAdminComponent;